// extracted by mini-css-extract-plugin
module.exports = {"LoginModal":"LoginModal_LoginModal__QxAM_","Header":"LoginModal_Header__CRRU9","SocialLogins":"LoginModal_SocialLogins__yyAat","FacebookLogin":"LoginModal_FacebookLogin___s_IF"};